const gallery = document.querySelectorAll('.js-product-gallery');

gallery.forEach((elem) => {
  const galleryList = elem.querySelectorAll('.gallery__image img');

  // Create a GSAP timeline for each gallery with a staggered animation on each image
  const tl = gsap.timeline({ paused: true }); // start paused so we can trigger on hover
  // tl.to(galleryList, { scale: 1.5, opacity: 1, duration: .625, stagger: .3125, ease: "power2.out" });

  // Define the matchMedia to handle screen size conditions
  const mm = gsap.matchMedia();

  // For devices with width 750px and above
  mm.add("(min-width: 750px)", () => {
    tl.to(galleryList, { scale: 1.5, opacity: 1, duration: .625, stagger: .3125, ease: "power2.out" });
  });

  // For devices up to 749px wide
  mm.add("(max-width: 749px)", () => {
    tl.to(galleryList, { scale: 2.5, opacity: 1, duration: .625, stagger: .3125, ease: "power2.out" });
  });


  ScrollTrigger.create({
    trigger: elem,
    start: "50% bottom", 
    onEnter: () => tl.play(),
    onLeaveBack: () => tl.reverse(),
    toggleActions: "play none none reverse"
  });
});